<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      title: "Dashboard",
      text: "Customer",
      text1: "Dashboard",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/customer/user-dashboard");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <h4 class="mb-3">Dashboard</h4>
            <div class="row mb-4">
              <div class="col-xxl-3 col-md-6">
                <div class="card dash-widget">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <span
                          class="dash-icon bg-primary-transparent d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <i class="ti ti-shopping-cart"></i>
                        </span>
                        <div class="ms-2">
                          <span class="fs-14">Total Orders</span>
                          <h5><span class="counter">27</span></h5>
                        </div>
                      </div>
                      <span class="badge badge-success"
                        ><i class="ti ti-circle-arrow-up me-1"></i>16%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-3 col-md-6">
                <div class="card dash-widget">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <span
                          class="dash-icon bg-secondary-transparent d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <i class="ti ti-wallet"></i>
                        </span>
                        <div class="ms-2">
                          <span class="fs-14">Total Spend</span>
                          <h5>$ <span class="counter">2500</span></h5>
                        </div>
                      </div>
                      <span class="badge badge-danger"
                        ><i class="ti ti-circle-arrow-down me-1"></i>5%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-3 col-md-6">
                <div class="card dash-widget">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <span
                          class="dash-icon bg-success-transparent d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <i class="ti ti-cards"></i>
                        </span>
                        <div class="ms-2">
                          <span class="fs-14">Wallet</span>
                          <h5>$ <span class="counter">200</span></h5>
                        </div>
                      </div>
                      <span class="badge badge-danger"
                        ><i class="ti ti-circle-arrow-down me-1"></i>5%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-3 col-md-6">
                <div class="card dash-widget">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <span
                          class="dash-icon bg-info-transparent d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <i class="ti ti-cards"></i>
                        </span>
                        <div class="ms-2">
                          <span class="fs-14">Total Savings</span>
                          <h5>$ <span class="counter">354</span></h5>
                        </div>
                      </div>
                      <span class="badge badge-success"
                        ><i class="ti ti-circle-arrow-up me-1"></i>16%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xxl-5 col-lg-5 d-flex">
                <div class="w-100">
                  <h5 class="mb-3">Recent Transaction</h5>
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <tbody>
                        <tr>
                          <td>
                            <div class="d-flex align-items-center">
                              <span
                                class="dash-icon-1 bg-gray d-flex justify-content-center align-items-center rounded-circle avatar avatar-lg me-2"
                              >
                                <i class="ti ti-devices-2 fs-20 text-dark"></i>
                              </span>
                              <div>
                                <h6 class="fs-14">Service Booking</h6>
                                <span class="text-gray fs-12">
                                  <i class="feather-calendar"></i>
                                  22 Sep 2023
                                  <span class="ms-2">
                                    <i class="feather-clock"></i>
                                    10:12 AM
                                  </span>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-end">
                            <h6>$280.00</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="d-flex align-items-center">
                              <span
                                class="dash-icon-1 bg-gray d-flex justify-content-center align-items-center rounded-circle avatar avatar-lg me-2"
                              >
                                <i class="ti ti-refresh fs-20 text-dark"></i>
                              </span>
                              <div>
                                <h6 class="fs-14">Service Refund</h6>
                                <span class="text-gray fs-12">
                                  <i class="feather-calendar"></i>
                                  15 Oct 2022
                                  <span class="ms-2">
                                    <i class="ti ti-clock me-1"></i>
                                    14:36 PM
                                  </span>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-end">
                            <h6>$395.00</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="d-flex align-items-center">
                              <span
                                class="dash-icon-1 bg-gray d-flex justify-content-center align-items-center rounded-circle avatar avatar-lg me-2"
                              >
                                <i class="ti ti-wallet fs-20 text-dark"></i>
                              </span>
                              <div>
                                <h6 class="fs-14">Wallet Topup</h6>
                                <span class="text-gray fs-12">
                                  <i class="feather-calendar"></i>
                                  18 Oct 2022
                                  <span class="ms-2">
                                    <i class="ti ti-clock me-1"></i>
                                    15:19 PM
                                  </span>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-end">
                            <h6>$1000.00</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="d-flex align-items-center">
                              <span
                                class="dash-icon-1 bg-gray d-flex justify-content-center align-items-center rounded-circle avatar avatar-lg me-2"
                              >
                                <i class="ti ti-devices-2 fs-20 text-dark"></i>
                              </span>
                              <div>
                                <h6 class="fs-14">Service Booking</h6>
                                <span class="text-gray fs-12">
                                  <i class="feather-calendar"></i>
                                  28 Oct 2022
                                  <span class="ms-2">
                                    <i class="ti ti-clock me-1"></i>
                                    11:17 AM
                                  </span>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-end">
                            <h6>$598.65</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="d-flex align-items-center">
                              <span
                                class="dash-icon-1 bg-gray d-flex justify-content-center align-items-center rounded-circle avatar avatar-lg me-2"
                              >
                                <i class="ti ti-devices-2 fs-20 text-dark"></i>
                              </span>
                              <div>
                                <h6 class="fs-14">Service Booking</h6>
                                <span class="text-gray fs-12">
                                  <i class="feather-calendar"></i>
                                  10 Nov 2022
                                  <span class="ms-2">
                                    <i class="ti ti-clock me-1"></i>
                                    09:13 AM
                                  </span>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-end">
                            <h6>$300.00</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="d-flex align-items-center">
                              <span
                                class="dash-icon-1 bg-gray d-flex justify-content-center align-items-center rounded-circle avatar avatar-lg me-2"
                              >
                                <i class="ti ti-devices-2 fs-20 text-dark"></i>
                              </span>
                              <div>
                                <h6 class="fs-14">Service Booking</h6>
                                <span class="text-gray fs-12">
                                  <i class="feather-calendar"></i>
                                  10 Nov 2022
                                  <span class="ms-2">
                                    <i class="ti ti-clock me-1"></i>
                                    09:13 AM
                                  </span>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-end">
                            <h6>$300.00</h6>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-xxl-7 col-lg-7 d-flex">
                <div class="w-100">
                  <h5 class="mb-3">Recent Booking</h5>
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <tbody>
                        <tr>
                          <td>
                            <router-link to="/booking/booking-details" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/providers/provider-15.jpg"
                                  class="img-fluid"
                                  alt="img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Computer Repair</h6>
                                  <span class="text-gray fs-12">
                                    <i class="feather-calendar me-1"></i>
                                    10 Nov 2022
                                  </span>
                                </div>
                              </div>
                            </router-link>
                          </td>
                          <td>
                            <a class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/user/user-01.jpg"
                                  class="rounded-circle img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">John Smith</h6>
                                  <span class="text-gray fs-14">john@gmail.com</span>
                                </div>
                              </div>
                            </a>
                          </td>
                          <td class="text-end">
                            <a href="javascript:void(0);" class="btn btn-light btn-sm"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <router-link to="/booking/booking-details" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/providers/provider-13.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Car Repair</h6>
                                  <span class="text-gray fs-12 me-1">
                                    <i class="feather-calendar"></i>
                                    15 Oct 2022
                                  </span>
                                </div>
                              </div>
                            </router-link>
                          </td>
                          <td>
                            <a href="javascript:void(0);" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/user/user-02.jpg"
                                  class="rounded-circle img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Timothy</h6>
                                  <span class="text-gray fs-14">timothy@gmail.com</span>
                                </div>
                              </div>
                            </a>
                          </td>
                          <td class="text-end">
                            <a href="javascript:void(0);" class="btn btn-light btn-sm"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <router-link to="/booking/booking-details" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/providers/provider-16.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Interior Designing</h6>
                                  <span class="text-gray fs-12 me-1">
                                    <i class="feather-calendar"></i>
                                    18 Oct 2022
                                  </span>
                                </div>
                              </div>
                            </router-link>
                          </td>
                          <td>
                            <a class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/user/user-03.jpg"
                                  class="rounded-circle img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Jordan</h6>
                                  <span class="text-gray fs-14">jordan@gmail.com</span>
                                </div>
                              </div>
                            </a>
                          </td>
                          <td class="text-end">
                            <a href="javascript:void(0);" class="btn btn-light btn-sm"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <router-link to="/booking/booking-details" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/providers/provider-17.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Steam Car Wash</h6>
                                  <span class="text-gray fs-12 me-1">
                                    <i class="feather-calendar"></i>
                                    28 Oct 2022
                                  </span>
                                </div>
                              </div>
                            </router-link>
                          </td>
                          <td>
                            <a href="javascript:void(0);" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/user/user-05.jpg"
                                  class="rounded-circle img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Armand</h6>
                                  <span class="text-gray fs-14">armand@gmail.com</span>
                                </div>
                              </div>
                            </a>
                          </td>
                          <td class="text-end">
                            <a href="javascript:void(0);" class="btn btn-light btn-sm"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <router-link to="/booking/booking-details" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/providers/provider-19.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">House Cleaning</h6>
                                  <span class="text-gray fs-12 me-1">
                                    <i class="feather-calendar"></i>
                                    10 Nov 2022
                                  </span>
                                </div>
                              </div>
                            </router-link>
                          </td>
                          <td>
                            <a href="javascript:void(0);" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/user/user-04.jpg"
                                  class="rounded-circle img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Joseph</h6>
                                  <span class="text-gray fs-14">joseph@gmail.com</span>
                                </div>
                              </div>
                            </a>
                          </td>
                          <td class="text-end">
                            <a href="javascript:void(0);" class="btn btn-light btn-sm"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <router-link to="/booking/booking-details" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/providers/provider-09.jpg"
                                  class="img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Car Repair</h6>
                                  <span class="text-gray fs-12 me-1">
                                    <i class="feather-calendar"></i>
                                    10 Nov 2022
                                  </span>
                                </div>
                              </div>
                            </router-link>
                          </td>
                          <td>
                            <a href="javascript:void(0);" class="d-flex">
                              <span class="avatar avatar-lg me-2">
                                <img
                                  src="@/assets/img/user/user-06.jpg"
                                  class="rounded-circle img-fluid"
                                  alt="Img"
                                />
                              </span>
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="fs-14">Adrian</h6>
                                  <span class="text-gray fs-14">jadrian@gmail.com</span>
                                </div>
                              </div>
                            </a>
                          </td>
                          <td class="text-end">
                            <a href="javascript:void(0);" class="btn btn-light btn-sm"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
